var _G;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { G, Path } from "react-native-svg";
var SvgIconSounds = function SvgIconSounds(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    overflow: "visible",
    preserveAspectRatio: "none",
    style: {
      display: "block"
    },
    viewBox: "0 0 22 22"
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    stroke: "#FFE9A8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement(Path, {
    fill: "#FFE9A8",
    d: "M10.083 4.308 5.5 8.25H1.833v5.5H5.5l4.583 3.942z"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M14.208 7.792a4.583 4.583 0 0 1 0 6.416M17.417 4.583a9.167 9.167 0 0 1 0 12.834"
  }))));
};
export default SvgIconSounds;